import React from 'react';

function EmailTemplate() {
  return (
    <React.Fragment>
      <svg
        width="26"
        height="27"
        viewBox="0 0 40 41"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.07525 1.8774C6.13732 1.8774 4.27876 2.64724 2.90843 4.01756C1.53811 5.38789 0.768265 7.24645 0.768265 9.18438V26.7211C0.768265 28.6591 1.53811 30.5176 2.90843 31.888C4.27876 33.2583 6.13732 34.0281 8.07525 34.0281H9.53664V23.7983C9.53664 21.8604 10.3065 20.0019 11.6768 18.6315C13.0471 17.2612 14.9057 16.4914 16.8436 16.4914H32.919V9.18438C32.919 7.24645 32.1492 5.38789 30.7788 4.01756C29.4085 2.64724 27.5499 1.8774 25.612 1.8774H8.07525ZM8.07525 9.18438C8.07525 8.79679 8.22922 8.42508 8.50328 8.15102C8.77735 7.87695 9.14906 7.72298 9.53664 7.72298H24.1506C24.5382 7.72298 24.9099 7.87695 25.184 8.15102C25.458 8.42508 25.612 8.79679 25.612 9.18438C25.612 9.57197 25.458 9.94368 25.184 10.2177C24.9099 10.4918 24.5382 10.6458 24.1506 10.6458H9.53664C9.14906 10.6458 8.77735 10.4918 8.50328 10.2177C8.22922 9.94368 8.07525 9.57197 8.07525 9.18438Z"
          fill="#00CA94"
        />
        <path
          d="M12.9325 23.6317C12.9858 22.5063 13.4703 21.4446 14.2856 20.6669C15.1008 19.8892 16.1841 19.4552 17.3108 19.455H34.8476C35.9742 19.4552 37.0576 19.8892 37.8728 20.6669C38.688 21.4446 39.1726 22.5063 39.2259 23.6317L26.0792 30.9357L12.9325 23.6317ZM26.7865 33.8848L39.2317 26.9724V35.5304C39.2317 36.6931 38.7698 37.8083 37.9476 38.6305C37.1255 39.4526 36.0103 39.9146 34.8476 39.9146H17.3108C16.148 39.9146 15.0329 39.4526 14.2107 38.6305C13.3885 37.8083 12.9266 36.6931 12.9266 35.5304V26.9724L25.3689 33.8848C25.5862 34.0056 25.8306 34.069 26.0792 34.069C26.3277 34.069 26.5722 34.0056 26.7894 33.8848"
          fill="#2C2C2C"
        />
      </svg>
    </React.Fragment>
  );
}

export default EmailTemplate;
